import { useTranslation } from 'react-i18next';

export const useJournalExport = () => {
    const { t } = useTranslation();

    return { t };
};
